module.exports = __webpack_public_path__ + "title.3f1f478a.png";